import React, { useContext } from 'react';
import { Grid, makeStyles, Typography } from '@material-ui/core';
import { ProfileContext } from '../../../../services/profile/profile.context';
import { urlConfig } from '../../../../config/urlConfig';
import useIslogin from '../../../../components/Hook/useIslogin';
import useFetch from '../../../../services/global/useFetch';
import { MeetingPreload } from '../meeting-preload';
import { MemoriesCard } from './memories-card';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      width: '30%',
    },
  };
});
export const MemoriesContainer = () => {
  useIslogin();
  const classes = useStyles();
  const { user } = useContext(ProfileContext);
  const { data, isPending, error } = useFetch(urlConfig.meeting_memory_url);

  return (
    <>
      {isPending && <MeetingPreload />}
      {error && (
        <Typography variant='h6' color='primary'>
          {error}
        </Typography>
      )}
      <Grid container justifyContent='flex-start' spacing={2}>
        {data &&
          data.length > 0 &&
          data.map((item) => (
            <Grid
              key={item.id}
              item
              xs={12}
              sm={6}
              md={4}
              lg={4}
              className={classes.root}
            >
              <MemoriesCard meeting={item} key={item.id} user={user} />
            </Grid>
          ))}
      </Grid>
    </>
  );
};
